module.exports = __webpack_public_path__ + "static/media/icon-summer.2a224dc0.svg";